/* global axios */
import ApiClient from '../ApiClient';

class MyAiChatMessages extends ApiClient {
  constructor() {
    super('my_ai/my_ai_chat_threads', { accountScoped: true });
  }

  get(threadId) {
    return axios.get(`${this.url}/${threadId}/my_ai_chat_messages`);
  }

  create({ threadId, ...rest }) {
    return axios.post(`${this.url}/${threadId}/my_ai_chat_messages`, rest);
  }
}

export default new MyAiChatMessages();
